import { useState } from 'react';

export default function WindowsDoorFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How much does window replacement cost in El Paso?',
      answer: 'Window replacement costs in El Paso typically range from $400 to $1,200 per window, depending on the type, size, and material. Vinyl windows are generally the most affordable option ($400-$700), while wood windows can cost $800-$1,200 or more. Factors affecting cost include window style, energy efficiency ratings, installation complexity, and whether custom sizing is needed.'
    },
    {
      question: 'What are the most energy-efficient windows for El Paso\'s climate?',
      answer: 'For El Paso\'s hot, sunny climate, look for windows with low-E (low-emissivity) coatings, double or triple-pane glass, and low U-factors (0.30 or less) and Solar Heat Gain Coefficients (SHGC of 0.25 or less). Vinyl and fiberglass frames offer excellent insulation. Energy Star certified windows designed for the South-Central climate zone are ideal for reducing cooling costs and UV damage.'
    },
    {
      question: 'How long does it take to replace windows and doors?',
      answer: 'A typical window replacement takes 30-60 minutes per window for standard installations. A full-house window replacement (10-15 windows) usually takes 1-2 days. Entry door installation typically takes 4-6 hours, while patio door installation can take 6-8 hours. Custom or complex installations may require additional time. Most contractors can provide a specific timeline during the estimate.'
    },
    {
      question: 'Do I need a permit for window and door replacement in El Paso?',
      answer: 'In El Paso, permits are typically required for window and door replacements, especially if you\'re changing the size of the opening or making structural modifications. Simple like-for-like replacements may not require permits in some cases. Your contractor should handle permit applications and ensure all work meets local building codes. Always verify permit requirements with the City of El Paso Building Inspection Department.'
    },
    {
      question: 'What\'s the difference between vinyl, wood, and fiberglass windows?',
      answer: 'Vinyl windows are low-maintenance, affordable, and energy-efficient but offer limited color options. Wood windows provide classic beauty and excellent insulation but require regular maintenance and are more expensive. Fiberglass windows combine the best of both—they\'re durable, low-maintenance, energy-efficient, and can be painted, but cost more than vinyl. For El Paso\'s climate, vinyl and fiberglass are popular choices due to their durability and minimal upkeep.'
    },
    {
      question: 'How can I tell if my windows need to be replaced?',
      answer: 'Signs you need window replacement include: drafts or air leaks around frames, condensation between glass panes, difficulty opening or closing windows, visible damage or rot to frames, high energy bills, outside noise easily heard inside, and fading furniture or flooring from UV exposure. If your windows are over 15-20 years old, replacement may improve energy efficiency and home value even without obvious problems.'
    },
    {
      question: 'What type of entry door is best for security and energy efficiency?',
      answer: 'Steel and fiberglass doors offer the best combination of security and energy efficiency. Steel doors are extremely strong and dent-resistant, while fiberglass doors provide superior insulation and can mimic the appearance of wood. Look for doors with multi-point locking systems, solid cores, and Energy Star certification. For El Paso, choose doors with low U-factors (0.17 or less) and proper weather stripping to handle temperature extremes.'
    },
    {
      question: 'Are there financing options available for window and door replacement?',
      answer: 'Yes, many El Paso window and door contractors offer financing options including zero-interest promotional periods, low monthly payments, and flexible terms. Some manufacturers provide their own financing programs. Additionally, you may qualify for energy efficiency rebates from El Paso Electric or tax credits for installing Energy Star certified products. Ask contractors about available financing and incentive programs during your consultation.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about window and door replacement in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-teal-500 flex-shrink-0`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
